import { render, staticRenderFns } from "./PresentationLetter.vue?vue&type=template&id=86b1b62a&scoped=true"
import script from "./PresentationLetter.vue?vue&type=script&lang=js"
export * from "./PresentationLetter.vue?vue&type=script&lang=js"
import style0 from "./PresentationLetter.vue?vue&type=style&index=0&id=86b1b62a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b1b62a",
  null
  
)

export default component.exports